// extracted by mini-css-extract-plugin
export default {"zoomModal":"d4-z"};